import { render, staticRenderFns } from "./WidgetPassageLinks.vue?vue&type=template&id=050f634e&"
import script from "./WidgetPassageLinks.vue?vue&type=script&lang=js&"
export * from "./WidgetPassageLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetPassageLinks.vue"
export default component.exports